// The homepage is also routed as /brand/{brand} (Global.asax "homepage-cover-photos"),
// which pins a specific cover-photo sheet row. Replaces Page.RouteData.Values("brand").
export default () => {
  const match = window.location.pathname.match(/^\/brand\/([a-zA-Z0-9-]+)\/?$/)

  return {
    requestedCoverPhoto: match ? match[1] : null
  }
}
